import * as React from 'react';



export default function Utenti(props) {
  const user=props.user;
  return (
    <><p>Ciao Utenti</p></>
  );
}
